import * as Sentry from "@sentry/vue";
import { AxiosError, InternalAxiosRequestConfig } from "axios";

import { getAuthClient } from "@/modules/authorisation/authClient";
import { useAuthorisationStore } from "@/modules/authorisation/authorisationStore";

export async function onRequestSuccess(config: InternalAxiosRequestConfig) {
  try {
    const authClient = await getAuthClient();
    const token = await authClient.getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      try {
        await useAuthorisationStore().onTokenUpdate(token);
      } catch (e) {
        Sentry.captureException(e);
      }
    } else {
      Sentry.captureException("No token present after getAccessToken", {
        contexts: {
          token_request: {
            timestamp: new Date().toISOString(),
          },
        },
      });
    }
    return config;
  } catch (e) {
    const authClient = await getAuthClient();
    Sentry.captureException(e, {
      contexts: {
        token_request: {
          timestamp: new Date().toISOString(),
        },
      },
    });
    await authClient.login();
    throw e;
  }
}

export function onRequestFailed(error: AxiosError) {
  return Promise.reject(error);
}
